<template>
  <div class="flex flex-col gap-y-3">
    <c_cell title="客户">
      <template #default>
        <strong>{{ state.model?.customer?.name }}</strong>
        <text class="ml-3 text-gray-400">
          {{ state.model?.customer?.number }}
        </text>
      </template>
    </c_cell>
    <c_cell title="款项说明" :value="state.model?.intro" />
    <ul class="bg-gray-100 rounded-md p-2.5 flex gap-x-3">
      <li class="flex-1 font-bold">收款记录</li>
      <c_cell
        title="金额"
        :size="12"
        :value="$priceFormat(state.model?.amount)"
        value-class="text-orange-400 font-bold"
      />
      <c_cell
        title="已收"
        :size="12"
        :value="$priceFormat(state.model?.collected_amount)"
        value-class="text-orange-400 font-bold"
      />
      <c_cell
        title="欠款"
        :size="12"
        :value="$priceFormat(state.model?.uncollected_amount)"
        value-class="text-red-500 font-bold"
      />
    </ul>
    <div>
      <div class="px-4 py-3">
        <ul
          class="grid gap-x-3 text-sm items-center"
          style="grid-template-columns: 100px 100px 1fr 100px 150px"
        >
          <text>{{ state.model?.number }}</text>
          <li>
            <text>{{ state.model?.add_admin_name }}</text>
            <text class="text-xs text-gray-400 ml-2">{{
              state.model?.add_department_name
            }}</text>
          </li>
          <text class="text-xs text-gray-400">{{
            state.model?.create_time
          }}</text>
          <c_cell :size="12" title="收款金额" :value="state.model?.amount" />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customer_collected_plan_detail } from "@/http/customer";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoad();
    });
    const onLoad = () => {
      if (props.id) {
        customer_collected_plan_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data || {};
          }
        });
      }
    };
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
